module.exports = __webpack_public_path__ + "img/dog-personalised.dc76d0b5.webp";